import { render } from "./ExcessReport.vue?vue&type=template&id=26f3d12d"
import script from "./ExcessReport.vue?vue&type=script&lang=js"
export * from "./ExcessReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__